import actionTypes from 'redux/actionTypes';

export function loadTemplateOnEdit(data) {
	return {
		type: actionTypes.LOAD_TEMPLATE_ON_EDIT,
		payload: data
	};
}

export function loadPreviewOnEdit(data) {
	return {
		type: actionTypes.LOAD_PREVIEW_ON_EDIT,
		payload: data
	};
}

export function getTempates(data) {
	return {
		type: actionTypes.GET_TEMPLATES,
		payload: data
	};
}

export function getTempatesSuccess(result) {
	return {
		type: actionTypes.GET_TEMPLATES_SUCCESS,
		payload: result
	};
}

export function getTempatesFailure(error) {
	return {
		type: actionTypes.GET_TEMPLATES_FAILURE,
		payload: error
	};
}

export function getCustomAttribute(data) {
	return {
		type: actionTypes.GET_CUSTOM_ATTRIBUTE,
		payload: data
	};
}

export function getCustomAttributeSuccess(result) {
	return {
		type: actionTypes.GET_CUSTOM_ATTRIBUTE_SUCCESS,
		payload: result
	};
}

export function getCustomAttributeFailure(error) {
	return {
		type: actionTypes.GET_CUSTOM_ATTRIBUTE_FAILURE,
		payload: error
	};
}

export function setSelectedTemplate(data) {
	return {
		type: actionTypes.SELECTED_TEMPLATE,
		payload: data
	};
}

export function getSBUDepartments(data) {
	return {
		type: actionTypes.GET_SBU_DEPARTMENTS,
		payload: data
	};
}

export function getSBUDepartmentsSuccess(result) {
	return {
		type: actionTypes.GET_SBU_DEPARTMENTS_SUCCESS,
		payload: result
	};
}

export function getSBUDepartmentsFailure(error) {
	return {
		type: actionTypes.GET_SBU_DEPARTMENTS_FAILURE,
		payload: error
	};
}

export function getSubTempateDetails(data) {
	return {
		type: actionTypes.GET_SUB_TEMPLATE_DETAILS,
		payload: data
	};
}

export function getSubTempateDetailsSuccess(result) {
	return {
		type: actionTypes.GET_SUB_TEMPLATE_DETAILS_SUCCESS,
		payload: result
	};
}

export function getSubTempateDetailsFailure(error) {
	return {
		type: actionTypes.GET_SUB_TEMPLATE_DETAILS_FAILURE,
		payload: error
	};
}

export function resetSubTempates() {
	return {
		type: actionTypes.RESET_SUB_TEMPLATE_DETAILS
	};
}

export function getCannedReports(data) {
	return {
		type: actionTypes.GET_CANNED_REPORTS,
		payload: data
	};
}

export function getCannedReportsSuccess(result) {
	return {
		type: actionTypes.GET_CANNED_REPORTS_SUCCESS,
		payload: result
	};
}

export function getCannedReportsFailure(error) {
	return {
		type: actionTypes.GET_CANNED_REPORTS_ERROR,
		payload: error
	};
}

export function getCustomDatasetDetails(data) {
	return {
		type: actionTypes.GET_CUSTOM_DATASET_DETAILS,
		payload: data
	};
}

export function getCustomDatasetDetailsSuccess(result) {
	return {
		type: actionTypes.GET_CUSTOM_DATASET_DETAILS_SUCCESS,
		payload: result
	};
}

export function getCustomDatasetDetailsFailure(error) {
	return {
		type: actionTypes.GET_CUSTOM_DATASET_DETAILS_FAILURE,
		payload: error
	};
}

export function getSavedCustomDataset(data) {
	return {
		type: actionTypes.GET_SAVED_CUSTOM_DATASET,
		payload: data
	};
}

export function getSavedCustomDatasetSuccess(result) {
	return {
		type: actionTypes.GET_SAVED_CUSTOM_DATASET_SUCCESS,
		payload: result
	};
}

export function getSavedCustomDatasetFailure(error) {
	return {
		type: actionTypes.GET_SAVED_CUSTOM_DATASET_FAILURE,
		payload: error
	};
}

export function saveCustomDataset(data) {
	return {
		type: actionTypes.SAVE_CUSTOM_DATASET,
		payload: data
	};
}

export function saveCustomDatasetSuccess(result) {
	return {
		type: actionTypes.SAVE_CUSTOM_DATASET_SUCCESS,
		payload: result
	};
}
export function resetSaveSuccessFlag() {
	return {
		type: actionTypes.RESET_SAVE_SUCCESS_FLAG,
		payload: false
	};
}
export function setDatasetExistsFlag(payload) {
	return {
		type: actionTypes.SET_DATASET_EXISTS_FLAG,
		payload: payload
	};
}

export function setCustomDatasetName(payload) {
	return {
		type: actionTypes.SET_CUSTOM_DATASET_NAME,
		payload: payload
	};
}

export function updateCustomDataset(payload) {
	return {
		type: actionTypes.UPDATE_CUSTOM_DATASET,
		payload: payload
	};
}

export function updateCustomDatasetSuccess(result) {
	return {
		type: actionTypes.UPDATE_CUSTOM_DATASET_SUCCESS,
		payload: result
	};
}

export function updateCustomDatasetFailure(result) {
	return {
		type: actionTypes.UPDATE_CUSTOM_DATASET_FAILURE,
		payload: result
	};
}

export function saveCustomDatasetFailure(result) {
	return {
		type: actionTypes.SAVE_CUSTOM_DATASET_FAILURE,
		payload: result
	};
}

export function deleteCustomDataset(data) {
	return {
		type: actionTypes.DELETE_CUSTOM_DATASET,
		payload: data
	};
}

export function deleteCustomDatasetSuccess(result) {
	return {
		type: actionTypes.DELETE_CUSTOM_DATASET_SUCCESS,
		payload: result
	};
}
export function resetCustomDatasetDeleteSuccess() {
	return {
		type: actionTypes.RESET_DELETE_DATASET_SUCCESS_FLAG,
		payload: false
	};
}

export function deleteCustomDatasetFailure(result) {
	return {
		type: actionTypes.DELETE_CUSTOM_DATASET_FAILURE,
		payload: result
	};
}
